// EINFACH NUR EIN TEST COMMENTAR

import { Component, ElementRef, HostListener, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, input, output } from '@angular/core';
import { Router } from '@angular/router';
import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';


import { BlocklyDbType } from '@shared/index';
import { BlocklyStorageService } from 'src/app/shared/services/blockly-storage.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';

import { Multiselect } from '@mit-app-inventor/blockly-plugin-workspace-multiselect';
import { DrawerModule } from 'primeng/drawer';
import { BlocklyPluginsDrawerContentComponent } from "src/app/blockly-plugins-drawer-content/blockly-plugins-drawer-content.component";
import { BlocklyPluginsService } from 'src/app/blockly-plugins.service';
import { BlockSearchService } from 'src/app/shared/services/block-search.service';
import { BlocklyClipboardService } from 'src/app/shared/services/blockly-clipboard.service';
import { BlocklyVariableRegistryService } from 'src/app/shared/services/blockly-variable-registry.service';
import { DialogRecorderIdRegistryService } from 'src/app/shared/services/dialog-recorder-id-registry.service';
import { EditorItemsService } from 'src/app/shared/services/editor-items.service';
import { EventIdRegistryService } from 'src/app/shared/services/event-id-registry.service';
import { GroupchatChannelRegistryService } from 'src/app/shared/services/groupchat-channel-registry.service';
import { IFTHEN_CONFIGURE_VARS_CALLBACK_KEY, WENNDANN_SPECIFIC_CATEGORY_NAME } from './blockly-categories/wenndann-specific.category';
import './blockly-custom-renderer'; // Register LightBorderThrasos renderer
import { BlocklyEditorApiService } from './blockly-editor-api.service';
import { BlocklyHelperService } from './blockly-helper.service';
import { BlocklyMenuService } from './blockly-menu.service';
import './blockly-toolbox-search-de'; // Register toolbox-search category (DE)
import { synchronizeWorkspaceVariables } from './blockly-variable-cleanup';
import { BlocklyVariableDialogComponent } from './blockly-variable-dialog.component';
import { BLOCKLY_DUMMY } from './blocky-types.types';
import './field-multiline-modal'; // Register FieldMultilineModal with Blockly field registry
import { registerVariableActionHandler } from './field-variable-actions';

type ToolboxItemInfo = Blockly.utils.toolbox.ToolboxItemInfo;


export type BlocklyChangedEvent = {
  code: string,
  xml: string
}


@Component({
  selector: 'app-blockly-editor',
  imports: [DrawerModule, BlocklyPluginsDrawerContentComponent, BlocklyVariableDialogComponent],
  templateUrl: './blockly-editor.component.html',
  styleUrl: './blockly-editor.component.scss'
})
export class BlocklyEditorComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('debugtxt') public debugtxt!: ElementRef;
  @ViewChild(BlocklyVariableDialogComponent) private variableDialog!: BlocklyVariableDialogComponent;
  private disposeVariableActions?: () => void;
  public readonly uniqueId = input.required<string>();
  public readonly blocklyAsCode = output<BlocklyChangedEvent>();
  public readonly codeChanged = output<string>();
  public showPluginsDrawer = false;
  public blocklyHelperIsOpen = false;
  public blocking = false;
  public searchVisible = false;
  public plugin_manage_menu_itemName = '⚙️ verwalten';
  private readonly MODE_TOGGLE_TO_EXPERT = 'zum Experten-Modus';
  private readonly MODE_TOGGLE_TO_STANDARD = 'zum Standard-Modus';
  public toolboxModeToggleName = 'zum Experten-Modus';
  public currentXML: string = "";
  public currentCode: string = "";
  public toolboxMode: 'standard' | 'expert' = 'standard';
  private toolboxContent: Blockly.utils.toolbox.ToolboxItemInfo[] = [];
  private expertToolboxContent: Blockly.utils.toolbox.ToolboxItemInfo[] = [];
  private originalToolbox: ToolboxItemInfo[] = [];
  private loadedXml: string = "";
  private blocklyChangeTimeout: number | NodeJS.Timeout = 0;
  private blocklyIsInitialed: boolean = false;
  private disposeClipboardRegistration?: () => void;
  private multiselectPlugin?: Multiselect;
  private variableCleanupScheduled = false;
  private isSynchronizingVariables = false;
  constructor(

    private ngZone: NgZone,
    private blockyStorage: BlocklyStorageService,
    private editorItemService: EditorItemsService,
    private belocklyMenu: BlocklyMenuService,
    private blockSearch: BlockSearchService,
    private BH: BlocklyHelperService,
    public rss: RouteShareService,
    public blocklyPluginsService: BlocklyPluginsService,
    public blocklyMenuService: BlocklyMenuService,
    private blocklyClipboard: BlocklyClipboardService,
    private blocklyEditorApi: BlocklyEditorApiService,
    private eventIdRegistry: EventIdRegistryService,
    private dialogRecorderIdRegistry: DialogRecorderIdRegistryService,
    private variableRegistry: BlocklyVariableRegistryService,
    private groupchatChannelRegistry: GroupchatChannelRegistryService,
    private router: Router

  ) {






  }

  //

  public getRawBlocks(pluginTXT: string): string[] {
    return ["xxx"];
  }

  private makeToggleItem(targetMode: 'expert' | 'standard'): ToolboxItemInfo {
    const toExpert = targetMode === 'expert';
    return {
      kind: 'category',
      name: toExpert ? this.MODE_TOGGLE_TO_EXPERT : this.MODE_TOGGLE_TO_STANDARD,
      colour: toExpert ? '#E65100' : '#546E7A',
      cssconfig: {
        row: 'blockly-mode-toggle',
        icon: toExpert ? 'ri-flask-line' : 'ri-arrow-go-back-line'
      }
    } as unknown as ToolboxItemInfo;
  }

  private readonly searchItem: ToolboxItemInfo = { kind: 'search', name: 'Suche', contents: [] } as unknown as ToolboxItemInfo;

  @HostListener('document:keydown', ['$event'])
  public onKeydown(event: KeyboardEvent): void {
    if (event.key === 'f' && (event.metaKey || event.ctrlKey)) {
      // Wenn der Code-Preview-Bereich (Textarea) den Fokus hat, soll die
      // native Browser-Suche funktionieren statt der Blockly-Suche.
      if (this.isTextInputTarget(event.target)) {
        return;
      }
      event.preventDefault();
      this.toggleSearch();
    }
  }

  private isTextInputTarget(target: EventTarget | null): boolean {
    const element = target as HTMLElement | null;
    if (!element) {
      return false;
    }
    const tagName = element.tagName;
    return tagName === 'TEXTAREA' || tagName === 'INPUT' || element.isContentEditable;
  }

  public toggleSearch() {
    this.searchVisible = !this.searchVisible;
    if (this.searchVisible) {
      this.toolboxContent.unshift(this.searchItem);
    } else {
      const idx = this.toolboxContent.indexOf(this.searchItem);
      if (idx >= 0) this.toolboxContent.splice(idx, 1);
    }
    const workspace = Blockly.getMainWorkspace();
    // @ts-ignore
    workspace.updateToolbox({ kind: 'categoryToolbox', contents: this.toolboxContent });
    if (this.searchVisible) {
      // Focus the search input after toggling on
      setTimeout(() => {
        const input = document.getElementById('toolbox-search-input') as HTMLInputElement | null;
        input?.focus();
      }, 100);
    }
  }

  public switchToolbox(mode: 'standard' | 'expert') {
    this.toolboxMode = mode;
    this.toolboxModeToggleName = mode === 'standard' ? this.MODE_TOGGLE_TO_EXPERT : this.MODE_TOGGLE_TO_STANDARD;
    const toggleItem = this.makeToggleItem(mode === 'standard' ? 'expert' : 'standard');
    const contents = mode === 'expert'
      ? [toggleItem, ...this.expertToolboxContent]
      : this.toolboxContent;
    const workspace = Blockly.getMainWorkspace();
    // @ts-ignore
    workspace.updateToolbox({ kind: 'categoryToolbox', contents });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['uniqueId']) {
      this.belocklyMenu.refreshDynamicBlocks();
      this.refreshWennDannSpecificCategory();
      this.loadWorkspace();
      this.markDeprecatedBlocks(Blockly.getMainWorkspace());
      this.blocklyEditorApi.updateContext(this.uniqueId(), this.toolboxContent, this.expertToolboxContent, this.toolboxMode);
    }

  }

  /**
   * Fügt die kontextabhängige Kategorie "Wenn-Dann Spezifische Werte" in die Gruppe
   * "Start & Ablauf" von this.toolboxContent ein (bzw. entfernt eine veraltete Instanz,
   * falls kein Wenn-Dann mehr aktiv ist). Reine Datenstruktur-Mutation ohne Seiteneffekte
   * auf den Workspace – wird sowohl beim initialen Aufbau (ngOnInit, vor initBlockly())
   * als auch bei jedem späteren Editor-Wechsel (refreshWennDannSpecificCategory()) genutzt.
   */
  private mergeWennDannSpecificCategoryIntoToolboxContent(): boolean {
    const newCategory = this.belocklyMenu.buildWennDannSpecificCategory();
    let startAblaufGroupFound = false;
    this.toolboxContent = this.toolboxContent.map((item: any) => {
      if (item.kind === 'category' && item.name === 'Start & Ablauf') {
        startAblaufGroupFound = true;
        const contents = (item.contents ?? []).filter((c: any) => c.name !== WENNDANN_SPECIFIC_CATEGORY_NAME);
        if (newCategory) {
          contents.push(newCategory);
        }
        return { ...item, contents };
      }
      return item;
    });
    return startAblaufGroupFound;
  }

  /**
   * Baut die kontextabhängige Sidebar-Kategorie "Wenn-Dann Spezifische Werte" innerhalb
   * der Gruppe "Start & Ablauf" neu auf und pusht die Änderung an den bereits laufenden
   * Workspace. Muss bei jedem Editor-Wechsel (uniqueId-Change) erneut aufgerufen werden,
   * da die Toolbox-Struktur sonst nur einmalig in ngOnInit() gebaut wird. Für den
   * initialen Aufbau (bevor der Workspace existiert) siehe stattdessen
   * mergeWennDannSpecificCategoryIntoToolboxContent(), das direkt in ngOnInit() aufgerufen wird.
   */
  private refreshWennDannSpecificCategory(): void {
    if (!this.blocklyIsInitialed || this.toolboxContent.length === 0) {
      return;
    }
    if (!this.mergeWennDannSpecificCategoryIntoToolboxContent()) {
      return;
    }
    const workspace = Blockly.getMainWorkspace();
    if (workspace && this.toolboxMode === 'standard') {
      // @ts-ignore
      workspace.updateToolbox({ kind: 'categoryToolbox', contents: this.toolboxContent });
    }
  }

  /**
   * Navigiert zum "Wenn-Dann"-Tab und öffnet dort direkt den Detail-Drawer des aktuell
   * im Scripting-Editor aktiven Wenn-Dann (zum Konfigurieren der Variablen).
   * Wird als Blockly-Flyout-Button-Callback registriert (siehe initBlockly()).
   */
  private navigateToIfthenVarsConfig(): void {
    const ifthenItem = this.rss.editorItems.ifthen.find(ifthen => ifthen.uniqueId === this.rss.editorItem?.uniqueId);
    if (!ifthenItem) {
      return;
    }
    void this.router.navigate(['/bot-admin', this.rss.botConfig._id, 'if-then'], { queryParams: { open: ifthenItem.id } });
  }

  public clearWorkspace() {
    const workspace = Blockly.getMainWorkspace();
    if (this.rss.editorItem) {
      this.rss.editorItem.isDirty = false;
    }
    workspace.clear();
    workspace.clearUndo();
  }


  private _getWorkspaceXML() {
    const workspace = Blockly.getMainWorkspace();
    const xml = Blockly.Xml.workspaceToDom(workspace);
    const xmlText = Blockly.Xml.domToText(xml);

    return xmlText;

  }

  public invalidateView() {

    setTimeout(() => {
      const workspace = Blockly.getMainWorkspace() as Blockly.WorkspaceSvg;
      Blockly.svgResize(workspace);
    }, 10);
  }

  private markDeprecatedBlocks(workspace: any) {
    if (!workspace) return;
    const allBlocks = workspace.getAllBlocks(false);
    for (const block of allBlocks) {
      this.markDeprecatedBlock(block);
    }
  }

  private markDeprecatedBlock(block: any) {
    if (!block) return;
    if (this.BH.DEPRECATED_BLOCKS.includes(block.type)) {
      block.setWarningText("Dieser Block ist veraltet und sollte nicht mehr verwendet werden.");
      const svgRoot = block.getSvgRoot();
      if (svgRoot) {
        svgRoot.classList.add('blocklyDeprecated');
      }
    }
  }

  public loadWorkspace(isRetry = false) {
    if (!this.blocklyIsInitialed) return;



    if (this.rss.editorItem) {
      const xmlText = this.rss.editorItem.xml;
      const code = this.rss.editorItem.code;
      this.loadedXml = xmlText;
      try {
        const workspace = Blockly.getMainWorkspace() as Blockly.WorkspaceSvg;
        const xml = Blockly.utils.xml.textToDom(xmlText);
        //@ts-ignore
        Blockly.Xml.clearWorkspaceAndLoadFromXml(xml, workspace);
        // Variablen aus allen Editoren erfassen und den aktuelleren Stand des
        // geöffneten Editors darüberlegen.
        this.variableRegistry.refresh();
        this.variableRegistry.updateFromEditor(this.rss.editorItem.uniqueId, xmlText);
        this.synchronizeVariables(workspace);
        // Undo-Stack leeren, damit Strg+Z nicht den initialen Load rückgängig macht (AITOOLS-1963)
        workspace.clearUndo();
      } catch (err) {
        console.error("Fehler beim Laden des Blockly-Workspaces:", err);
        if (!isRetry) {
          // Einmaliger Retry: Blockly-Definitionen könnten beim ersten Aufruf noch nicht
          // vollständig registriert sein (Plugin-Loading async)
          setTimeout(() => this.loadWorkspace(true), 250);
        }
      }
      this.invalidateView();
    }
  }

  public ngOnDestroy() {
    this.disposeVariableActions?.();
    this.blocklyIsInitialed = false;
    this.multiselectPlugin?.dispose();
    this.disposeClipboardRegistration?.();
    this.blocklyEditorApi.deactivate();
    delete window.BLOCKLY_EDITOR;
    const workspace = Blockly.getMainWorkspace();
    console.log(workspace);
    if (workspace) {
      console.log("destroyed WS");
      workspace.dispose();
    }
  }



  public openBottly() {
    this.blocklyHelperIsOpen = true;
    //@ts-ignore
    window.RAGBOT.setChatbotUrlOnce("https://ki-toolbox.reflactportal.com/de/bot/69806fe9b66e6602ebfd0f34/chat");
    //@ts-ignore
    window.RAGBOT.openChatbot();
    //@ts-ignore
    window.RAGBOT.blockBackground();



    // this.openOverlay();




  }





  public onPluginDeleted(pluginId: string) {
    console.log("PLUGIN DELETED EVENT IM BLOCKLY EDITOR", pluginId);
    // ENTFERNE DEN PLUGIN KATEGORIE EINTRAG AUS DEM TOOLBOX CONTENT
    this.toolboxContent = this.toolboxContent.map((item: any) => {

      if (item.kind === 'category' && item.name === 'Erweiterungen') {
        console.log("FOUND EXTENSIONS CATEGORY", item);
        return {
          ...item,
          contents: (item.contents ?? []).filter((contentItem: any) => contentItem.name !== this.blocklyPluginsService.pluginIdToNameMap.get(pluginId))
        };
      }
      return item;
    });

    const workspace = Blockly.getMainWorkspace();
    //@ts-ignore
    workspace.updateToolbox({ kind: 'categoryToolbox', contents: this.toolboxContent });

  }

  public onPluginAdded(event: ToolboxItemInfo) {





    /***** PLUGIM ADD LOGIC */
    console.log("ADD", this.toolboxContent);
    this.toolboxContent = this.toolboxContent.map((item: any) => {

      if (item.kind === 'category' && item.name === 'Erweiterungen') {
        console.log("FOUND EXTENSIONS CATEGORY", item);
        return {
          ...item,
          contents: [event, ...(item.contents ?? [])]
        };
      }
      return item;
    });

    const workspace = Blockly.getMainWorkspace();
    //@ts-ignore
    workspace.updateToolbox({ kind: 'categoryToolbox', contents: this.toolboxContent });




  }

  public async ngOnInit() {
    await this.groupchatChannelRegistry.refresh();
    const items: ToolboxItemInfo[] = this.belocklyMenu.getItems();
    const expertItems: ToolboxItemInfo[] = this.belocklyMenu.getExpertItems();
    this.originalToolbox = items;
    this.toolboxContent.push(
      ...items
    );
    this.expertToolboxContent.push(
      ...expertItems
    );
    const pluginData = await this.blocklyPluginsService.getPlugins();


    const extensionsCategory: ToolboxItemInfo[] = [];
    extensionsCategory.push({
      kind: 'category',
      name: this.plugin_manage_menu_itemName,
    });

    for (const pluginId of pluginData.plugins) {
      const pluginTXT = await this.blocklyPluginsService.fetchPluginByPath(pluginId);

      this.blocklyPluginsService.pluginIdToBlockIdsMap.set(pluginId, this.blocklyPluginsService.extractBlockIdsFromPluginTxt(pluginTXT));

      const pluginCategory = this.blocklyPluginsService.registerPluginByTxt(pluginTXT);
      if (pluginCategory) {
        //@ts-ignore
        this.blocklyPluginsService.setPluginIdToName(pluginId, pluginCategory.name);
        extensionsCategory.push(pluginCategory);
      }



    }



    const pluginsCategory: ToolboxItemInfo = {
      kind: 'category',
      name: 'Erweiterungen',
      colour: '#546E7A',
      contents: extensionsCategory.toReversed(),
      cssconfig: { row: 'blockly-extensions-row' }
    } as unknown as ToolboxItemInfo;

    this.toolboxContent.push(pluginsCategory);

    // Toggle-Eintrag für Experten-Modus
    this.toolboxContent.push(this.makeToggleItem('expert'));

    // Veraltete Blöcke – ganz unten, kleiner
    this.toolboxContent.push(this.belocklyMenu.getDeprecatedItem() as unknown as ToolboxItemInfo);

    // Kontextabhängige Kategorie "Wenn-Dann Spezifische Werte": muss VOR initBlockly()
    // in toolboxContent gemergt werden, damit sie auch dann korrekt erscheint, wenn beim
    // Öffnen des Scripting-Editors bereits ein Wenn-Dann-Editor ausgewählt war (rss.editorItem
    // ist zu diesem Zeitpunkt bereits gesetzt, ngOnChanges lief zuvor noch mit leerem
    // toolboxContent und konnte die Kategorie daher noch nicht einfügen).
    this.mergeWennDannSpecificCategoryIntoToolboxContent();

    this.initBlockly();

    // Register window.BLOCKLY_EDITOR API
    const wsForApi = Blockly.getMainWorkspace() as Blockly.WorkspaceSvg;
    window.BLOCKLY_EDITOR = this.blocklyEditorApi.activate(
      wsForApi,
      this.uniqueId(),
      this.toolboxContent,
      this.expertToolboxContent,
      this.toolboxMode,
      () => this.saveWorkspace(),
      (mode) => this.switchToolbox(mode)
    );

    // Für scripts/blockly-docs/ (Playwright-Extraktion der Block-Dokumentation).
    // Blockly + javascriptGenerator sind ES-Module-Imports, nicht automatisch auf window -
    // daher hier explizit mit ausliefern, damit die Extraktion sie referenzieren kann.
    window.BLOCKLY_DOCS_DEBUG = {
      Blockly,
      javascriptGenerator,
      standardToolbox: items,
      expertToolbox: expertItems,
      deprecatedBlockTypes: this.BH.DEPRECATED_BLOCKS,
      blocks: this.blockSearch.getAllBlocks(),
    };


    const workspace = Blockly.getMainWorkspace();
    workspace.addChangeListener((event) => {
      //@ts-ignore
      if (event.type == 'toolbox_item_select') {
        // Flyout-Blöcke als deprecated markieren (kurze Verzögerung, da Flyout erst gerendert wird)
        setTimeout(() => {
          const flyout = (workspace as any).getFlyout?.();
          if (flyout) {
            const flyoutWorkspace = flyout.getWorkspace?.();
            if (flyoutWorkspace) {
              this.markDeprecatedBlocks(flyoutWorkspace);
            }
          }
        }, 50);
      }

      //@ts-ignore
      if (event.type == 'toolbox_item_select' && event.newItem == this.plugin_manage_menu_itemName) {

        this.showPluginsDrawer = true;
        //@ts-ignore
        window.RAGBOT.closeChatbot();


      }

      //@ts-ignore
      if (event.type == 'toolbox_item_select' && (event.newItem === this.MODE_TOGGLE_TO_EXPERT || event.newItem === this.MODE_TOGGLE_TO_STANDARD)) {
        this.ngZone.run(() => {
          this.switchToolbox(this.toolboxMode === 'standard' ? 'expert' : 'standard');
        });
      }

    });


    //@ts-ignore
    this.blockSearch.cancleEvent.subscribe((e) => {
      const workspace = Blockly.getMainWorkspace();
      //@ts-ignore
      workspace.updateToolbox(
        {
          kind: 'categoryToolbox',
          contents: this.toolboxContent
        }
      );
    });
    //@ts-ignore
    this.blockSearch.resultEvent.subscribe((e) => {
      const newToolbox = {
        kind: 'categoryToolbox',
        contents: [e]
      };
      const workspace = Blockly.getMainWorkspace();
      //@ts-ignore
      workspace.updateToolbox(newToolbox);
      setTimeout(() => {
        const workspace = Blockly.getMainWorkspace();
        //@ts-ignore
        const toolbox = workspace.getToolbox();
        if (!toolbox) return;
        const categories = toolbox.getToolboxItems();
        const suchKategorie = categories.find((cat: any) => cat.getName?.().includes('Treffer'));
        //console.log(suchKategorie);
        if (suchKategorie) {
          toolbox.setSelectedItem(suchKategorie);
        } else {
          console.warn("Kategorie 'Gefunden' nicht gefunden oder nicht erweiterbar");
        }
      }, 100);
    });














  }



  public onSearch(searchTerm: string): void {
    const workspace = Blockly.getMainWorkspace();

    //    (workspace as any).updateToolbox(newToolbox);
  }


  private initBlockly() {


    //    this.generateArrayBlocks();
    const ModernTheme = Blockly.Theme.defineTheme('modern', {
      base: Blockly.Themes.Classic,
      name: 'modern',
      componentStyles: {
        workspaceBackgroundColour: '#F0F0F0',
        toolboxBackgroundColour: '#EAEAEA',
        toolboxForegroundColour: '#333',
        flyoutBackgroundColour: '#f9f9f9',
        flyoutForegroundColour: '#000',
        flyoutOpacity: 0.8,
        scrollbarColour: '#ccc',
        insertionMarkerColour: '#000',
        insertionMarkerOpacity: 0.3,
        markerColour: '#000',
        cursorColour: '#d0d0d0',
      }
    });

    const blocklyConfig: Blockly.BlocklyOptions = {
      theme: ModernTheme,
      comments: true,
      disable: true,
      grid: {
        spacing: 20,        // Abstand der Rasterpunkte
        length: 3,          // Länge der Rasterlinien
        colour: '#ccc',     // Farbe des Gitters
        snap: true          // Blöcke am Raster ausrichten
      },
      renderer: 'light_border_thrasos',
      move: {
        scrollbars: { horizontal: true, vertical: true },
        drag: true,
        wheel: true
      },
      zoom: {
        controls: true,
        wheel: true,
        pinch: true,
        minScale: 0.8
      },
      sounds: false,
      trashcan: true,

      toolbox: {
        kind: 'categoryToolbox',
        contents: this.toolboxContent
      }
    };

    // console.log(this.toolboxContent);


    /*
      Object.entries(Blockly.Msg).forEach(([key, value]) => {
      console.log(`${key}: ${value}`);
    });
     */





    const workspace = Blockly.inject('blocklyDiv', blocklyConfig);
    this.disposeVariableActions?.();
    this.disposeVariableActions = registerVariableActionHandler(workspace, request => {
      this.ngZone.run(() => this.variableDialog.open(request));
    });
    this.disposeClipboardRegistration?.();
    this.disposeClipboardRegistration = this.blocklyClipboard.registerWorkspace(workspace);

    // Verhindert, dass Blöcke gelöscht werden, wenn sie in die linke
    // Toolbox-/Flyout-Zone gezogen werden. Beide Klassen (Toolbox und Flyout)
    // erben von DeleteArea und sind als separate DELETE_AREA-Targets registriert.
    // Wir überschreiben wouldDelete() an den konkreten Instanzen (kein globaler
    // Prototype-Patch), damit der Trashcan unberührt bleibt.
    const flyout = workspace.getFlyout();
    if (flyout) {
      (flyout as any).wouldDelete = () => false;
    }
    const toolbox = workspace.getToolbox();
    if (toolbox) {
      (toolbox as any).wouldDelete = () => false;
    }

    // Blockly v12 Kompatibilitäts-Shim: block.setEnabled() wurde in v12 durch
    // setDisabledReason() ersetzt. Das Multiselect-Plugin ruft noch setEnabled()
    // auf – dieser Shim stellt die Kompatibilität her.
    if (!(Blockly.BlockSvg.prototype as any).setEnabled) {
      (Blockly.BlockSvg.prototype as any).setEnabled = function (enabled: boolean) {
        //@ts-ignore
        this.setDisabledReason(!enabled, 'MANUALLY_DISABLED');
      };
    }

    // Initialize workspace multi-select plugin.
    this.multiselectPlugin = new Multiselect(workspace);
    this.multiselectPlugin.init({
      // Keep multiselect easy to activate on macOS and Windows.
      multiSelectKeys: ['Shift', 'Meta', 'Control'],
      multiselectIcon: {
        hideIcon: false,
      },
      multiselectCopyPaste: {
        crossTab: true,
        menu: true,
      },
    });

    // Hat-Blöcke (startBlockNew): beim Löschen nur den Hat-Block selbst entfernen,
    // den darunter hängenden Stapel auf dem Workspace stehen lassen.
    // Patch auf BlockSvg.prototype.dispose – greift für alle Löschpfade
    // (Kontextmenü, DEL-Taste, Multiselect).
    // Der disconnect läuft MIT Events, damit Focus-Manager und Multiselect-Plugin
    // korrekt reagieren. Events.setGroup stellt sicher dass Undo atomar bleibt.
    if (!(Blockly as any).BlockSvg.prototype._origDispose) {
      const origDispose = (Blockly as any).BlockSvg.prototype.dispose;
      (Blockly as any).BlockSvg.prototype._origDispose = origDispose;
      (Blockly as any).BlockSvg.prototype.dispose = function (this: any, healStack: any, animate: any) {
        if (
          !this.previousConnection &&
          this.nextConnection?.isConnected() &&
          !this.workspace?.isFlyout &&
          !this.isDeadOrDying()
        ) {
          const alreadyInGroup = !!(Blockly.Events as any).getGroup?.();
          if (!alreadyInGroup) Blockly.Events.setGroup(true);
          this.nextConnection.disconnect();
          origDispose.call(this, healStack, animate);
          if (!alreadyInGroup) Blockly.Events.setGroup(false);
        } else {
          origDispose.call(this, healStack, animate);
        }
      };
    }

    // FocusManager-Patch: Blockly ruft intern focusNode(null) auf, wenn nach dem
    // Löschen eines Blocks kein fokussierbarer Nachbarknoten gefunden wird →
    // TypeError: Cannot read properties of null (reading 'canBeFocused').
    // Guard: Aufruf nur weiterleiten, wenn der Knoten ein gültiges IFocusableNode ist.
    const focusMgr = (Blockly as any).getFocusManager?.();
    if (focusMgr) {
      const fmProto = Object.getPrototypeOf(focusMgr);
      if (fmProto && typeof fmProto.focusNode === 'function' && !fmProto._patchedFocusNode) {
        const origFocusNode = fmProto.focusNode;
        fmProto.focusNode = function (this: any, node: any, ...args: any[]) {
          if (!node || typeof node.canBeFocused !== 'function') return;
          return origFocusNode.call(this, node, ...args);
        };
        fmProto._patchedFocusNode = true;
      }
    }

    workspace.registerButtonCallback(IFTHEN_CONFIGURE_VARS_CALLBACK_KEY, () => this.navigateToIfthenVarsConfig());

    this.blocklyIsInitialed = true;
    this.loadWorkspace();
    this.markDeprecatedBlocks(workspace);

    workspace.addChangeListener((event) => {
      // VERGLEICHT DEN EDITOR MIT DEM LETZEN GELADENEN AUS DEM STORAGE
      this.currentXML = this._getWorkspaceXML();
      const newCode = javascriptGenerator.workspaceToCode(workspace);
      const codeHasChanged = newCode !== this.currentCode;
      this.currentCode = newCode;
      if (codeHasChanged) {
        this.ngZone.run(() => {
          this.codeChanged.emit(this.currentCode);
        });
      }

      const ei = this.rss.editorItem;
      if (ei?.uniqueId) {
        const existingXML = this.blockyStorage.getStageXmlByUniqueId(ei.uniqueId);

        if (this.editorItemService.blocklyIsPossible()) {
          if (this.currentXML !== existingXML) {
            ei.isDirty = true;
            ei.xml = this.currentXML;
          }
        }

        // Update event ID registry with current editor content
        this.eventIdRegistry.updateFromEditor(ei.uniqueId, this.currentXML);
        // Update dialog recorder ID registry with current editor content
        this.dialogRecorderIdRegistry.updateFromEditor(ei.uniqueId, this.currentXML);
        // Update project-wide Blockly variable usage with current editor content
        this.variableRegistry.updateFromEditor(ei.uniqueId, this.currentXML);

        const isFieldChange = event.type === Blockly.Events.BLOCK_CHANGE
          && (event as Blockly.Events.BlockChange).element === 'field';
        if (event.type === Blockly.Events.BLOCK_DELETE || isFieldChange) {
          this.scheduleVariableSynchronization(workspace, event.group);
        }
      }



    });

    /*  DISABLES BLOCKS IF NOT ALLOWED ROOT LEVEL OF WORKSPACE */
    workspace.addChangeListener((event) => {
      if (event.type !== Blockly.Events.BLOCK_MOVE) return;
      //@ts-ignore
      const block = workspace.getBlockById(event.blockId);
      let blockAllowedUnnested = true;

      if (!block) return;

      if (block?.outputConnection !== null) { blockAllowedUnnested = false; }
      if (block?.type.startsWith("RAGAI_BUTTON")) {
        blockAllowedUnnested = false;
      }
      if (block?.type === "SKILL_JOINING") {
        blockAllowedUnnested = false;
      }

      if (['RAGAI_BUTTON', 'RAGAI_BUTTON_TEXT',

        BLOCKLY_DUMMY.COMPLETIONMESSAGECONTENT_IMAGE,
        BLOCKLY_DUMMY.COMPLETIONMESSAGECONTENT_TEXT,
        BLOCKLY_DUMMY.COMPLETIONMESSAGE].includes(block?.type)) { blockAllowedUnnested = false; };

      if (blockAllowedUnnested) return;
      const parent = block?.getParent();
      // Wenn kein Parent, also auf oberster Ebene → löschen oder markieren
      if (!parent) {
        // ❌ Variante 1: Block automatisch löschen
        // block.dispose(true); // true = mit Animation

        // ⚠️ Variante 2: Block markieren (z.B. mit Warnung)
        //@ts-ignore
        block.setWarningText("Dieser Block muss eingebettet sein!");

        //@ts-ignore
        block.setDisabledReason(true, "Dieser Block muss eingebettet sein!");
      } else {
        // Wenn er korrekt eingebettet ist, Warnung wieder entfernen
        //@ts-ignore
        block.setWarningText(null);
        //@ts-ignore
        block.setDisabledReason(false, "Dieser Block muss eingebettet sein!");
      }
    });

    /* DEPRECATED BLOCKS: Rote Umrandung + Warnung */
    workspace.addChangeListener((event) => {
      if (event.type !== Blockly.Events.BLOCK_CREATE) return;
      // Beim Duplizieren/Einfügen eines Blockstapels wird nur EIN Create-Event für den
      // obersten Block ausgelöst. `event.ids` enthält jedoch die IDs ALLER dabei neu
      // erzeugten Blöcke (inkl. verschachtelter Kind-Blöcke) – nur so werden auch
      // deprecated Blöcke innerhalb eines duplizierten Ober-Blocks korrekt markiert.
      //@ts-ignore
      const ids: string[] = event.ids ?? (event.blockId ? [event.blockId] : []);
      for (const id of ids) {
        const block = workspace.getBlockById(id);
        this.markDeprecatedBlock(block);
      }
    });









    /**  // DIESER CODE TUT NIX ABER WÜRDE ÄNDERUNGEN IM BLOCKLY MIT BEKOMMEN */
    /**  // also so etwas wie "chnages im blockly achtung vele events und nicht gut strukturiiert" */
    this.blockyStorage.blocklyUpdated.subscribe((data: BlocklyDbType) => {
      if (data.uniqueId === this.uniqueId()) {
        if (data.xml != this.loadedXml) {
          this.loadWorkspace();
        }
      }
    });

  }




  public saveWorkspace() {

    const workspace = Blockly.getMainWorkspace();
    this.synchronizeVariables(workspace);
    const code = javascriptGenerator.workspaceToCode(workspace);
    const xml = this._getWorkspaceXML();
    const uniqueId = this.rss.editorItem?.uniqueId;
    if (uniqueId) {
      this.variableRegistry.updateFromEditor(uniqueId, xml);
    }
    this.blocklyAsCode.emit({ code, xml });
  }

  private scheduleVariableSynchronization(workspace: Blockly.WorkspaceSvg, eventGroup: string): void {
    if (this.variableCleanupScheduled || this.isSynchronizingVariables) {
      return;
    }

    this.variableCleanupScheduled = true;
    queueMicrotask(() => {
      this.variableCleanupScheduled = false;
      if (this.blocklyIsInitialed) {
        const shouldRestoreEventGroup = Boolean(eventGroup) && !Blockly.Events.getGroup();
        if (shouldRestoreEventGroup) {
          Blockly.Events.setGroup(eventGroup);
        }
        try {
          this.synchronizeVariables(workspace);
        } finally {
          if (shouldRestoreEventGroup) {
            Blockly.Events.setGroup(false);
          }
        }
      }
    });
  }

  private synchronizeVariables(workspace: Blockly.Workspace): void {
    if (this.isSynchronizingVariables) {
      return;
    }

    this.isSynchronizingVariables = true;
    try {
      synchronizeWorkspaceVariables(workspace, this.variableRegistry.getAllVariableNames());
    } finally {
      this.isSynchronizingVariables = false;
    }
  }


  /***** ES GIBT EIN PLUGIN WO MIT MAN ARRAYS JOINEN KANN
   * ALSO STINC KONGATINIERUNG MACHEN KANN
   * das versuche ich ein zu bauen
   *
   * qivate generateArrayBlocks() {
      Blockly.defineBlocksWithJsonArray([
        {
          "type": "strings_join_with_space",
          "message0": "verbinde %1 mit Leerzeichen",
          "args0": [
            {
              "type": "input_value",
              "name": "ADD0"
            }
          ],
          "output": "String",
          "mutator": "controls_create_join_mutator",
          "colour": 160,
          "tooltip": "Verbindet alle Eingaben mit einem Leerzeichen zu einem String",
          "helpUrl": ""
        }
      ]);




      /* //@ts-ignore
      Blockly.JavaScript['array_join'] = function (block) {
        const array = Blockly.JavaScript.valueToCode(block, 'ARRAY', Blockly.JavaScript.ORDER_MEMBER) || '[]';
        const separator = Blockly.JavaScript.valueToCode(block, 'SEPARATOR', Blockly.JavaScript.ORDER_NONE) || '""';
        const code = `${array}.join(${separator})`;
        return [code, Blockly.JavaScript.ORDER_FUNCTION_CALL];
      }; */

  public showOverlay = false;

  public openOverlay() {
    this.showOverlay = true;
    setTimeout(() => {
      let overlay = document.getElementById('blockly-fullscreen-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'blockly-fullscreen-overlay';
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100vw';
        overlay.style.height = '100vh';
        overlay.style.background = 'rgba(0,0,0,0.5)';
        overlay.style.zIndex = '10010';
        overlay.onclick = () => this.closeOverlay();
        document.body.appendChild(overlay);
      } else {
        overlay.style.display = 'block';
      }
    }, 0);
  }

  public closeOverlay() {
    this.showOverlay = false;
    const overlay = document.getElementById('blockly-fullscreen-overlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
  }

}
